import React from 'react';
import HorizontalBoxPlot from './horizontal-box-plot';
import AcceptanceClassificationTooltip from './acceptance-likelihood/acceptance-classification-tooltip';
import {acceptanceLikelihoodClassification} from 'shared/college-profile/utils';

interface Props {
  college: {
    avgSatScore?: number;
    name: string;
    satCriticalReadingRange?: number[];
    satMathematicsRange?: number[];
  };
  userInfo: {
    satScore?: {
      score: number;
    };
  };
  showAdmissability?: boolean;
}

const SATSection = ({
  college: {avgSatScore, name, satCriticalReadingRange, satMathematicsRange},
  userInfo: {satScore},
  showAdmissability,
}: Props) => {
  const getAcceptanceLikelihoodClassification = () => {
    if (!satCriticalReadingRange || !satMathematicsRange || !satScore) {
      return '';
    }

    const twentyFifthPercentile = satCriticalReadingRange[0] + satMathematicsRange[0];
    const seventyFifthPercentile = satCriticalReadingRange[1] + satMathematicsRange[1];

    return acceptanceLikelihoodClassification(
      satScore.score,
      twentyFifthPercentile,
      seventyFifthPercentile
    );
  };

  if (!avgSatScore) {
    return null;
  }

  const points: {
    value: number;
    color: string;
    label?: string;
  }[] = [
    {
      value: avgSatScore,
      color: showAdmissability ? 'gray' : 'blue',
      label: `Avg Score: ${avgSatScore}`,
    },
  ];

  if (showAdmissability && satScore) {
    points.push({
      value: satScore.score,
      color: 'blue',
    });
  }

  return (
    <div className="college-profile-sat-act">
      <header className="college-profile-sat-act-header">Average SAT Score</header>

      {showAdmissability && (
        <div className="college-profile-sat-act-subheader">
          {satScore ? (
            <span>{`Compare your SAT score to ${name}’s averages.`}</span>
          ) : (
            <a href="/portfolio#scores">Enter your SAT Score to compare to SAT averages.</a>
          )}
        </div>
      )}

      <div className="college-profile-sat-act-range">
        <div className="college-profile-sat-act-plot">
          {showAdmissability && satScore && (
            <AcceptanceClassificationTooltip
              label="Your SAT"
              studentValue={satScore.score}
              classification={getAcceptanceLikelihoodClassification()}
              xValue={(satScore.score / 1600) * 100}
            />
          )}

          <HorizontalBoxPlot
            max={1600}
            min={0}
            points={points}
            tooltip={showAdmissability && !!satScore}
          />
        </div>

        <div className="college-score-range-label">
          <div className="college-score-range-label-content">{avgSatScore}</div>
        </div>
      </div>
    </div>
  );
};

export default SATSection;
